import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class InvalidExchangeDateError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.accountancy.validation.invalid-exchange-date');
    }
}
